import {useMemo} from "react";
import {RouteGroupSelectorProps, routeGroupsSelector, useGetAllRouteGroupsQuery} from "@ots-frontend/ots-data";
import * as CSS from 'csstype';
import {defaultMapMarkerColor, siteDisposalColor, transportLineColors} from "../theme/colors";

export type RouteGroupColorCode = {
  [key: string]: {
    index: number;
    name: string;
    color: CSS.Property.Color;
  };
};

export type UseGetRouteGroupColorCodeProps = RouteGroupSelectorProps & {
  // additional props here
}

export type UseGetRouteGroupColorCodeResult = {
  routeGroupColorCode?: RouteGroupColorCode
}

export const useGetRouteGroupColorCode = (props: UseGetRouteGroupColorCodeProps): UseGetRouteGroupColorCodeResult => {
  const {regionId} = props;

  const selectRouteGroups = useMemo(() => {
    return routeGroupsSelector();
  }, []);

  const {routeGroups} = useGetAllRouteGroupsQuery(regionId, {
    selectFromResult: (result) => ({
      routeGroups: selectRouteGroups(result, {regionId: regionId}),
    })
  });

  const _routeGroupColorCode = useMemo(() => {
    const colorCode: RouteGroupColorCode = {};

    const sortedRouteGroups = routeGroups.sort((a, b) => {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });

    let colorIndex = 0;
    sortedRouteGroups.forEach((value, index) => {
      if (colorIndex === transportLineColors.length - 1) {
        colorIndex = 0;
      }

      colorCode[value.id] = {
        index: index,
        name: value.name,
        color: transportLineColors[colorIndex++],
      };
    });

    colorCode['undefined'] = {
      index: -1,
      name: 'No Route Group',
      color: defaultMapMarkerColor,
    };

    colorCode['undefined-disposal'] = {
      index: -2,
      name: 'Disposal',
      color: siteDisposalColor,
    };

    if (Object.keys(colorCode).length > 0) {
      return colorCode;
    }
  }, [routeGroups]);

  return {
    routeGroupColorCode: _routeGroupColorCode
  };
};
